import React, { useState } from 'react'
import style from "./style/Header.module.css"
import logo from "../logoImg/logo.png"
import { Link } from 'react-router-dom'

function Header() {

    const [styleBergerMenu, setStyleBergerMenu] = useState(false)
    const [styleHeaderMenu, setStyleHeaderMenu] = useState(false)

    const changeClassNaming = () =>{
        
        setStyleBergerMenu(!styleBergerMenu)
        setStyleHeaderMenu(!styleHeaderMenu)
    }

    return (
        <header className={style.header}>
            <div className={style.header__container}>
                <div className={style.header__body}>
                    <a className={style.header__logo} href="#"><img src={logo} alt="Logo" /></a>
                    <div onClick={changeClassNaming} className={`${style.header__burger} ${styleBergerMenu ? style.active : ""}`}>
                        <span></span>
                    </div>
                    <nav className={`${style.header__menu} ${styleHeaderMenu ? style.active : ""}`}>
                        <ul className={style.header__list}>
                            <li><a className={style.header__li} href="#aboutMe">About me</a></li>
                            <li><Link className={style.header__li} to="/certificate">Certificates</Link></li>
                            <li><a className={style.header__li} href="#contactMe">Contact me</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    )
}

export default Header